module.exports = __webpack_public_path__ + "static/media/coin7.01487704.webp";